const tracker = {
    track: (name, data) => {
        const trackingData = {
            user_id: data.user.id,
            email: data.user.email,
            site_id: data.user.siteId,
            admin_site_link: process.env.REACT_APP_ACTIVE_ADMIN_URL + "/sites/" + data.user.siteId,
            admin_user_link: process.env.REACT_APP_ACTIVE_ADMIN_URL + "/users/" + data.user.id,
            site_url: data.user.sites.find(x => x.id === data.user.siteId).url,
            plan: data.user.plan,
            logins: data.user.logins,
            primary_domain: data.user.primaryDomain
        };
        window.analytics.track(name, trackingData)
    },
    identify: (userId, data) => {
        const userData = {
            user_id: data.user.id,
            email: data.user.email,
            site_id: data.user.siteId,
            admin_site_link: process.env.REACT_APP_ACTIVE_ADMIN_URL + "/sites/" + data.user.siteId,
            admin_user_link: process.env.REACT_APP_ACTIVE_ADMIN_URL + "/users/" + data.user.id,
            site_url: data.user.sites.find(x => x.id === data.user.siteId).url,
            plan: data.user.plan,
            logins: data.user.logins,
            primary_domain: data.user.primaryDomain
        };
        window.analytics.identify(userId, userData)
    }
}

export default tracker